import { render, staticRenderFns } from "./ResultSubcontract.vue?vue&type=template&id=377dddad&scoped=true&"
import script from "./ResultSubcontract.vue?vue&type=script&lang=js&"
export * from "./ResultSubcontract.vue?vue&type=script&lang=js&"
import style0 from "./ResultSubcontract.vue?vue&type=style&index=0&id=377dddad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377dddad",
  null
  
)

export default component.exports